module.exports = __webpack_public_path__ + "img/9791158881801.48c46f8f.jpg";